import { getI18nLanguage } from 'pricing-pages-ui-components/utils/languageUtils';
const KB_DOMAINS = {
  en: 'https://knowledge.hubspot.com',
  de: 'https://knowledge.hubspot.com/de',
  es: 'https://knowledge.hubspot.com/es',
  'pt-br': 'https://knowledge.hubspot.com/pt',
  fr: 'https://knowledge.hubspot.com/fr',
  ja: 'https://knowledge.hubspot.com/jp'
};
function getKnowledgeBaseUrl() {
  const lang = getI18nLanguage();
  return KB_DOMAINS[lang] || KB_DOMAINS.en;
}
export function getKBPaymentsUrl(appendPath) {
  const baseUrl = `${getKnowledgeBaseUrl()}/payments/payments-frequently-asked-questions`;
  return appendPath ? `${baseUrl}${appendPath}` : baseUrl;
}
export function getKBCurrenciesUrl() {
  return `${getKnowledgeBaseUrl()}/payment-processing/configure-currencies-for-commerce-hub`;
}